import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { ImovelType, PlanoType, SafraType } from '../../db/Orm';
import CardAntecipacao, { estado, labelEstado } from '../components/CardAntecipacao';
// import 'primereact/resources/themes/lara-light-indigo/theme.css'; // Escolha o seu tema preferido
import 'primereact/resources/primereact.min.css';                 // Estilos principais do PrimeReact
import 'primeicons/primeicons.css';
import { Card } from 'primereact/card';
import CadastroAntecipacao from './CadastroAntecipacao';

type Props = {
  show: boolean;
  hide: Function;
  planos: PlanoType[]
  propriedades: ImovelType[];
  safras: SafraType[]
  carregarPlanos: () => void;
}

export const DialogAntecipacoes = (props: Props) => {
  const toast = useRef<Toast | null>(null);
  const [showDialogAntecipacao, setShowDialogAntecipacao] = useState(false);
  const [antecipacao, setAntecipacao] = useState<any>(null)
  
  const status = (plano: PlanoType) => {
    return <>
      {labelEstado(plano)}
    </>
  }
  const [showCadastro, setShowCadastro] = useState(false)
  const handleSuccess = () => {
    if (toast.current) {
      toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Antecipação criada com sucesso!', life: 3000 });
    }
    props.carregarPlanos();
  };

  return (
    <Dialog header="Antecipações" visible={props.show} style={{ width: '70vw' }} onHide={() => { props.hide(); }} draggable={false} resizable={false}>
      <Toast ref={toast} position="center"></Toast>
      <CardAntecipacao antecipacao={antecipacao} propriedades={props.propriedades} />
      <Dialog header="Antecipação" visible={showDialogAntecipacao} style={{ width: '50vw' }} onHide={() => setShowDialogAntecipacao(false)} draggable={false} resizable={false}>
        <Toast ref={toast} position="center"></Toast>
        <CardAntecipacao antecipacao={antecipacao} propriedades={props.propriedades} />
      </Dialog>
      <CadastroAntecipacao show={showCadastro} setShow={setShowCadastro} propriedades={props.propriedades} safras={props.safras} onSuccess={handleSuccess} />
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '1rem' }}>
        <Button icon="pi pi-refresh" className="p-button-rounded p-button-text" onClick={() => props.carregarPlanos()} />
        <Button label="Nova Antecipação" icon="pi pi-plus" onClick={() => setShowCadastro(true)} />
      </div>
      <DataTable value={props.planos} selectionMode="single" selection={antecipacao} onRowSelect={(row) => setAntecipacao(row.data)} dataKey="id" scrollable>
        <Column body={(plano) => <>{plano.propriedade?.nome}</>} header="Imóvel"></Column>
        <Column body={(plano) => <>{plano.safra?.periodo}</>} header="Safra"></Column>
        <Column body={status} header="Status"></Column>
        <Column body={(antecipacao) => <Button label="Abrir" className="p-button-sm" onClick={() => { setAntecipacao(antecipacao); setShowDialogAntecipacao(true) }} />} style={{ width: '100px' }} />
      </DataTable>
    </Dialog>
  );
}
